<ng-template #newAppVersionAvailableTemplate>
	@if (appVersionState(); as appVersionState) {
	<lib-message [icon]="'appUpdate'" [type]="'info'" [title]="newVersionTitle()" class="push-bottom-md">
		<div>{{ newVersionText() }}</div>
		<div class="push-top-sm">
			<lib-button [buttonType]="'delete'" (click)="handleUpdateApp()">Update app</lib-button>
		</div>
	</lib-message>

	}
</ng-template>

<ng-template #contentTemplate>
	@if (appVersionState(); as appVersionState) { @if (appVersionState.isOutdated) {
	<ng-template [ngTemplateOutlet]="newAppVersionAvailableTemplate"></ng-template>
	} }
	<ng-content></ng-content>
</ng-template>

<ng-template #footerItemsTemplate let-section="section">
	@if (section.title) {
	<div class="push-bottom-md">
		<span class="w-footer-title">{{ section.title }}</span>
	</div>
	} @for (footerItem of section.items; track footerItem.text; let first = $first) {
	<div [class.push-top]="!first">
		<ng-template
			[ngTemplateOutlet]="footerItemTemplate"
			[ngTemplateOutletContext]="{ item: footerItem }"
		></ng-template>
	</div>
	}
</ng-template>
<ng-template #footerItemTemplate let-item="item">
	<div class="w-footer-item">
		<lib-link [routerLink]="item.routerLink" [anchorRoute]="item.anchorRoute">
			<div [class.link]="item.routerLink || item.anchorRoute ? true : false">
				@if (item.format === 'title') {
				<span class="w-footer-title">{{ item.text }}</span> } @else if (item.format === 'small') {
				<span class="w-footer-small">{{ item.text }}</span>
				} @else {
				{{ item.text }}
				}
			</div>
		</lib-link>
	</div>
</ng-template>

<ng-template #footerTemplate>
	<div class="w-footer">
		<div [ngStyle]="layoutSizeStyles()">
			<div libPad>
				@if (footerItems(); as footerItems) { @if (isMobileView()) {

				<div [libFlexRow]="true" [libFlexRowGap]="'16px'">
					@for (footerItem of footerItems.sectionB.items; track footerItem.text; let first = $first) {
					<div libFlexColumn [style.width]="calculateFlexWidth(2, 16)">
						<ng-template
							[ngTemplateOutlet]="footerItemTemplate"
							[ngTemplateOutletContext]="{ item: footerItem }"
						></ng-template>
					</div>
					}
				</div>

				<div class="push-top-md">
					<ng-template
						[ngTemplateOutlet]="footerItemsTemplate"
						[ngTemplateOutletContext]="{ section: footerItems.sectionC }"
					></ng-template>
				</div>
				<div class="push-top-md">
					<ng-template
						[ngTemplateOutlet]="footerItemsTemplate"
						[ngTemplateOutletContext]="{ section: footerItems.sectionA }"
					></ng-template>
				</div>
				} @else {
				<div [libFlexRow]="false" [libFlexRowGap]="'24px'" [libFlexRowAlign]="'start'">
					<div libFlexColumn [libFlexSize]="'fill'">
						<ng-template
							[ngTemplateOutlet]="footerItemsTemplate"
							[ngTemplateOutletContext]="{ section: footerItems.sectionA }"
						></ng-template>
					</div>
					<div libFlexColumn [libFlexSize]="'fill'">
						<ng-template
							[ngTemplateOutlet]="footerItemsTemplate"
							[ngTemplateOutletContext]="{ section: footerItems.sectionB }"
						></ng-template>
					</div>
					<div libFlexColumn [libFlexSize]="'fill'">
						<ng-template
							[ngTemplateOutlet]="footerItemsTemplate"
							[ngTemplateOutletContext]="{ section: footerItems.sectionC }"
						></ng-template>
					</div>
				</div>
				} }
			</div>
		</div>
	</div>
</ng-template>

<layout-primary-menu
	[toolbarMenuItems]="toolbarMenuItems()"
	[primaryMenuType]="primaryMenuType()"
	[parentRoutes]="parentRoutes()"
	[menuItems]="menuItems()"
	[pageTitle]="pageTitle()"
	[sideMenuCategories]="extendedSideMenuCategories()"
>
</layout-primary-menu>

@if (calculatedDesign(); as calculatedDesign) { @if (calculatedDesign === 'authPage') {

<div>
	<layout-toolbar-component
		[avatar]="pageAvatar()"
		[title]="pageTitle()"
		[subtitle]="pageSubtitle()"
		[buttons]="buttons()"
		[toolbarType]="'authPage'"
		[layoutMenuItems]="toolbarMenuItems()"
		[parentRoutes]="parentRoutes()"
	></layout-toolbar-component>

	<div class="push-top">
		<layout-auth-page
			[menuItems]="menuItems()"
			[pageMetadata]="pageMetadata()"
			[parentRoutes]="parentRoutes()"
			[layoutSize]="layoutSize()"
			[sharedData]="sharedData()"
			[secondaryMenuItems]="secondaryMenuItems()"
			(sharedDataUpdated)="sharedDataUpdated.emit($event)"
		>
			<div>
				<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
			</div>
		</layout-auth-page>
	</div>
</div>

} @else if (calculatedDesign === 'cleanPage') {

<div>
	<layout-toolbar-component
		[title]="pageTitle()"
		[buttons]="buttons()"
		[subtitle]="pageSubtitle()"
		[avatar]="pageAvatar()"
		[toolbarType]="'default'"
		[parentRoutes]="parentRoutes()"
		[layoutMenuItems]="toolbarMenuItems()"
	></layout-toolbar-component>
</div>

<div class="w-layout-wrapper">
	<div class="w-layout-content">
		<layout-clean-page [layoutSize]="layoutSize()">
			<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
		</layout-clean-page>
	</div>

	@if (includeFooter()) {
	<ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
	}
</div>

} @else if (calculatedDesign === 'focusedPage') {

<div>
	<layout-toolbar-component
		[title]="pageTitle()"
		[buttons]="buttons()"
		[subtitle]="pageSubtitle()"
		[avatar]="pageAvatar()"
		[toolbarType]="'default'"
		[parentRoutes]="parentRoutes()"
		[layoutMenuItems]="toolbarMenuItems()"
	></layout-toolbar-component>
</div>

<div class="w-layout-focused-page" [class.light]="theme() === 'light'" [class.dark]="theme() === 'dark'">
	<div class="w-layout-wrapper">
		<div class="w-layout-content push-top-xl">
			<layout-clean-page [layoutSize]="layoutSize()">
				<div>
					<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
				</div>
			</layout-clean-page>
		</div>
	</div>
</div>

} @else if (calculatedDesign === 'homePage') {

<div>
	<layout-toolbar-component
		[title]="pageTitle()"
		[buttons]="buttons()"
		[subtitle]="pageSubtitle()"
		[avatar]="pageAvatar()"
		[toolbarType]="'default'"
		[parentRoutes]="parentRoutes()"
		[layoutMenuItems]="toolbarMenuItems()"
	></layout-toolbar-component>
</div>
<div class="w-layout-wrapper">
	<div class="w-layout-content">
		<layout-home-page>
			<ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
		</layout-home-page>
	</div>
	@if (includeFooter()) {
	<ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
	}
</div>

} @else if (calculatedDesign === 'accountDisabled') {

<div>
	<layout-toolbar-component
		[title]="'Disabled'"
		[buttons]="[]"
		[subtitle]="undefined"
		[avatar]="undefined"
		[toolbarType]="'default'"
		[parentRoutes]="[]"
		[layoutMenuItems]="[]"
	></layout-toolbar-component>

	<div class="w-layout-wrapper">
		<div class="w-layout-content">
			<layout-home-page>
				<div>
					<div class="w-text-center pad-top-xl">
						<h2>Account disabled</h2>
						<p>Your account has been disabled. Please contact support or your coach.</p>
					</div>
				</div>
			</layout-home-page>
		</div>
	</div>
</div>

} @else { Invalid page design '{{ calculatedDesign }}' } }
